import { createContext, useEffect, useState, useCallback } from "react";
import axios from "../utils/axiosInstance";

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {

  const [wishlist, setWishlist] = useState([]);

  // ===============================
  // LOAD WISHLIST
  // ===============================
  const loadWishlist = useCallback(async () => {

    const token = localStorage.getItem("token");

    if (!token) {
//      setWishlist([]);
      return;
    }

    try {

      const res = await axios.get("/api/wishlist", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = res.data;

      if (Array.isArray(data)) {
        setWishlist(data);
      } else if (Array.isArray(data?.wishlist)) {
        setWishlist(data.wishlist);
      } else {
        setWishlist([]);
      }

    } catch (err) {

      console.error("Error fetching wishlist:", err);

      setWishlist([]);

    }

  }, []);


  // ===============================
  // LOAD ON PAGE LOAD
  // ===============================
  useEffect(() => {
   const token = localStorage.getItem("token");

    if (!token) return;
    loadWishlist();
  }, [loadWishlist]);


  // ===============================
  // ADD TO WISHLIST
  // ===============================
  const addToWishlist = async (productId) => {

    const token = localStorage.getItem("token");

  if (!token) {

    return;

  }

    try {

      await axios.post(`/api/wishlist/${productId}`);

      await loadWishlist();

    } catch (error) {

      console.error("Error adding to wishlist:", error);

      alert(
        error?.response?.data?.message ||
        "Could not add to wishlist"
      );

    }

  };


  // ===============================
  // REMOVE FROM WISHLIST
  // ===============================
  const removeFromWishlist = async (wishlistId) => {

    try {

      await axios.delete(`/api/wishlist/${wishlistId}`);

      setWishlist((items) =>
        items.filter((item) => item.id !== wishlistId)
      );

    } catch (error) {

      console.error("Error removing from wishlist:", error);

      alert("Could not remove from wishlist");

    }

  };

  const isWishlisted = (productId) => {

    if (!wishlist) return false;

    return wishlist.some(
      (item) => item.product?.id === productId
    );

  };


  // ===============================
  // CONTEXT PROVIDER
  // ===============================
  return (

    <WishlistContext.Provider
      value={{
        wishlist,
        addToWishlist,
        removeFromWishlist,
        isWishlisted,
        refreshWishlist: loadWishlist
      }}
    >

      {children}

    </WishlistContext.Provider>

  );

};